import axiosInstance from "./axiosInstance";

export const taskService = {
    // Отримання всіх задач
    async getTasks(page = 1, limit = 10) {
        try {
            const response = await axiosInstance.get("/tasks/list", {
                params: { page, limit }
            });
            return response.data; // { success, tasks, total, page, limit }
        } catch (error) {
            console.error("Error fetching tasks:", error);
            throw error;
        }
    },

    // Створення нової задачі
    async createTask(title, content) {
        try {
            const response = await axiosInstance.post("/tasks/create", {
                title,
                content
            });
            return response.data;
        } catch (error) {
            console.error("Error creating task:", error);
            throw error;
        }
    },

    // отримання задачі по id
    async getTaskById(taskId) {
        try {
            const response = await axiosInstance.get(`/tasks/${taskId}`);
            return response.data;
        } catch (error) {
            console.error(`Error fetching task with ID ${taskId}:`, error);
            throw error;
        }
    },

    // Оновлення задачі
    async updateTask(id, title, content) {
        try {
            const response = await axiosInstance.put(`/tasks/update/${id}`, {
                title,
                content
            });
            return response.data;
        } catch (error) {
            console.error("Error updating task:", error);
            throw error;
        }
    },

    async updateTaskStatus(id) {
        try {
            const response = await axiosInstance.put(
                `/tasks/update_status/${id}`
            );
            return response.data;
        } catch (error) {
            console.error("Error updating task status:", error);
            throw error;
        }
    },

    async deleteTasks(ids) {
        try {
            const response = await axiosInstance.delete("/tasks/delete", {
                data: { ids }
            });
            return response.data;
        } catch (error) {
            console.error("Error deleting tasks:", error);
            throw error;
        }
    }
};
